import fuzzysort from 'fuzzysort'

import { integrationName } from './helpers'

export const SEARCH_DATA_FIELD = 'searchData'

export const findMatchingIntegrations = (targets, text, searchKeys) => {
  if (text === null || text === undefined) {
    return []
  }

  const cleanTerm = text.trim()
  if (!cleanTerm) {
    return []
  }

  const matches = fuzzysort.go(cleanTerm, targets, {
    keys: searchKeys,
    threshold: 0.65, // match scores below this on a [0,1] scale will be discarded
  })

  const results = matches.map((o) => o.obj)
  return results
}

export const getIntegrationSearchData = (item) => {
  const fields = [integrationName(item)]

  if (item.tags) {
    fields.push(...item.tags)
  }

  if (item.admin) {
    fields.push('admin')
  }

  const text = fields.join(' ')
  return fuzzysort.prepare(text)
}
